module.exports = __webpack_public_path__ + "img/arrow-square-up.5b6fb5b0.svg";